// src/components/About/About.js

import React from "react";
import "../../styles/ijrr.css";

export default function About() {
  return (
    <div>
      {/* About Us Section */}
      <section className="about-us space-pb-80">
        <div className="container">
          <div className="row about-row">
            <div className="col-lg-5">
              <div className="img-wrap">
                <img
                  className="img-fluid"
                  src="../assets/images/ijrr/IJRR.png"
                  alt="about us"
                />

                <div className="contact-info">
                <a href="/contact" className="btn btn-primary">GET IN TOUCH</a>

                  {/* Social Icons */}
                  <div className="social-icons">
                    <a
                      href="https://facebook.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fa-brands fa-facebook"></i>
                    </a>
                    <a
                      href="https://twitter.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fa-brands fa-x"></i>
                    </a>
                    <a
                      href="https://linkedin.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fa-brands fa-linkedin"></i>
                    </a>
                  </div>

                  {/* Contact Information */}
                  <div className="contact-info-phone">
                    <a className="phone" href="tel:214-762-7295">
                      <i className="fa fa-phone" aria-hidden="true"></i>{" "}
                      214-762-7295
                    </a>
                    <a className="email" href="mailto:info@myjollyroger.com">
                      <i className="fa fa-envelope" aria-hidden="true"></i> info@myjollyroger.com
                    </a>
                  </div>

                  {/* Motto, Creed, and Code */}
                  <div className="motto-creed-code">
                    <p>
                      <span className="highlight">Motto:</span> “My Jolly Roger”
                    </p>
                    <p>
                      <span className="highlight">Creed:</span> “Live and Die
                      Under It”
                    </p>
                    <p>
                      <span className="highlight">Code:</span> The Articles of
                      Agreement
                    </p>
                  </div>

                  {/* Commitments Link */}
                  <a href="/commitments" className="commitments-link">
                    Commitments of the Pyrate’s Code
                  </a>
                </div>
              </div>
            </div>

            <div className="col-lg-7">
              <div className="aboutus-contain">
                <div>
                  <h2 className="original-title">
                    INTERNATIONAL JOLLY ROGER REGISTRY
                  </h2>
                  <br />

                  <p className="ijrr-text">
                    If you are a Pirate at heart, you are invited to become a member of the IJRR. Once a member, our platform
                    gets you started and supplies all the necessary tools to unlock the full potential of creating your own Personal
                    Brand! We help you get started with assisting you in selecting your image you want to use to brand your
                    identity. Then offering personalized branding strategies that are targeted more for the real world experience.
                  </p>
                  <br />
                  <p className="ijrr-text">
                    Once you become a Member, you will receive your authentic Membership Certificate along with your
                    personal flag and sticker with your selected image. You can then select from the many products you would
                    like to use to create and promote your Personal Brand, virtually and also having a real world presence.
                  </p>
                  <br />
                  <p className="ijrr-text">
                    How cool to be yourself and express your ideas and personal brand. Just like the pirates in the Golden Age
                    of Piracy that wanted freedom from authoritarian rule and to roam the open seas. Each captain personally
                    designed his own flag with his image he wanted to convey. We use that concept to start each member with a
                    flag to fly and represent their independence and individuality using their personal image. This will get you
                    started on your journey to create a Personal Brand of your own.
                  </p>
                  <br />
                  <p className="ijrr-text">
                    Personalized branding strategies are a main component of our platform. Our platform offers the tools and
                    expertise you need to elevate your brand. Show off who you are and share your enthusiasm and ideas with
                    other members and friends. Your selected image can be anything you want it to be. It can be a picture of
                    your family, a dog or cat, or any image you feel that represents your best interest as a person or possibly
                    reflects an idea you want to express. Once your image is selected and registered with the IJRR, it will not
                    issue a Membership Certificate or reproduce that image to anyone else, helping to secure your Personal
                    Identity and Brand.
                  </p>
                  <br />
                  <p className="ijrr-text">
                    Let’s not forget the other advantages of the IJRR memberships. The IJRR’s platform is there to enjoy and
                    get information about many different events and social media such as Pirate festivals around the world every
                    year, concerts, and events sponsored by IJRR. As IJRR grows in membership, new events and rewards for
                    members will be fun and memorable to enjoy.
                  </p>
                  <br />
                  <p className="ijrr-text">
                    Please enjoy our content on web and app and we appreciate anyone’s responses and comments on our site
                    and products. Everyone have a blessed day and be safe whether you're in full sail or not! Ayyyy matie!
                  </p>
                  <br />
                  <h3>
                    <i>
                      “Come experience the new Jolly Roger International Family.”
                    </i>
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}